import React, { useState, useEffect } from "react";
import { ReactComponent as Cross } from "../../../assets/analyse/Cross.svg";
import { ReactComponent as BackArrow } from "../../../assets/navbar/BackArrow.svg";
import firebase from "../../../firebase/config";
// import { toast } from "react-toastify";
import { ToastWarn, ToastSuccess } from "../../../commonComponents/ToastHelper";
import MainButton from "../../../commonComponents/MainButton";
import { isValidEmail } from "../../../utils/utils.js";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { addUserProfile, fetchAllUsers, setAllUsers, updateUserProfile, updateUserProfileLocal } from "../../../redux/actions/userActions";

const AddUserMenu = ({ addMenu, setAddMenu, is_modify_user, to_modify }) => {
  // REDUX
  const auth = useSelector((state) => state.firebase.auth);
  const dispatch = useDispatch();
  const addUserProfile_rd = (item) => dispatch(addUserProfile(item));
  const updateUserProfile_rd = (item) => dispatch(updateUserProfile(item));
  const updateUserProfileLocal_rd = (item) => dispatch(updateUserProfileLocal(item));
  const setAllUsers_rd = (item) => dispatch(setAllUsers(item));
  // const fetchAllUsers_rd = (item) => dispatch(fetchAllUsers(item));
  const add_user_profile_status = useSelector((state) => state.user.add_user_profile_status);

  const [customRole, setCustomRole] = useState(
    is_modify_user
      ? to_modify.data.organization_info.role.access
      : {
          analyse: { read: false, write: false },
          reduce: { read: false, write: false },
          communicate: { read: false, write: false },
        }
  );
  const [roleSelected, setRoleSelected] = useState(is_modify_user ? { id: to_modify.data.organization_info.role.id, name: to_modify.data.organization_info.role.name } : { id: "0", name: "null" });
  const [newrole, setNewRole] = useState(is_modify_user ? { id: to_modify.data.organization_info.role.id, name: to_modify.data.organization_info.role.name } : "");
  const [email, setEmail] = useState(to_modify ? to_modify.data.email : "");
  var menuPos = { x: 500, y: 150 };

  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const [rand_update, set_rand_update] = useState(null);
  // useEffect(() => {
  //   // console.log('ADD MENU CHANGED: ', add_user_profile_status)
  //   if (add_user_profile_status && add_user_profile_status.data && add_user_profile_status.data.message === "auth/email-already-exists") {
  //     ToastWarn("Utilisateur déjà invité. Nouvelle email-invitation envoyé.");
  //     setAllUsers_rd(null);
  //   } else if (add_user_profile_status && add_user_profile_status.data && add_user_profile_status.data.message === "analysis created succefully") {
  //     ToastSuccess("Email-invitation envoyé.");
  //     setAllUsers_rd(null);
  //   }
  // }, [add_user_profile_status]);

  const addButtonCallBack = async () => {
    //// data validation
    if (!isValidEmail(email)) {
      ToastWarn("Email invalide.");
      return;
    }
    if (roleSelected.id == 0) {
      ToastWarn("Pas de rôle sélectionné.");
      return;
    }

    const item = {
      user_email: email.trim(),
      user_role: roleSelected,
      // custom_role: customRole,
    };
    item.user_role.access = customRole;

    if (!is_modify_user) {
      await addUserProfile_rd(item);
    } else {
      item.user_id = to_modify.id;
      await updateUserProfile_rd(item);
      await updateUserProfileLocal_rd(item);
      set_rand_update(Math.random());
    }
    // close menu
    setAddMenu(0);
  };

  return (
    <div className={`h-[400px] w-[350px] bg-white rounded-lg shadow-xl border-[2px] border-gray-500/10 z-50`} style={{ position: "fixed", left: menuPos.x, top: menuPos.y }}>
      <div className="mx-[15px]">
        <div className="mt-[20px] flex justify-between w-full">
          <p className="font-Poppins-SemiBold text-xs">{is_modify_user ? "Modifier les rôles" : "Ajouter un membre"}</p>
          <div className="cursor-pointer">
            <Cross
              height={20}
              onClick={() => {
                setAddMenu(0);
              }}
            />
          </div>
        </div>
        <div className="w-full h-[1px] bg-gray-400/40 rounded-full mt-[10px]" />
        <div className="mt-[20px]">
          <p className="font-Poppins-Light text-xs">Adresse email</p>
          <input
            placeholder="nom@company.com"
            className="bg-[#F8FAFB] w-full h-[35px] rounded-lg text-sm pl-[10px] mt-[5px] font-Poppins-Light"
            disabled={is_modify_user}
            value={to_modify && to_modify.data.email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <div className="mt-[20px]">
          <p className="font-Poppins-Light text-xs">Rôle</p>
          <div>
            {addMenu >= 2 ? (
              <>
                <div className="bg-white shadow-sm border-[2px] border-gray-500/10 rounded-lg absolute w-[320px] z-50">
                  <div className="mt-[20px] ml-[10px] flex">
                    {newrole.id === "1" ? (
                      <>
                        <div className="rounded-full w-[20px] h-[20px] border-blue-500 border-[2px] flex items-center justify-center">
                          <div className="rounded-full w-[10px] h-[10px] bg-blue-500" />
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="rounded-full w-[20px] h-[20px] border-black border-[2px] flex items-center justify-center cursor-pointer"
                          onClick={() => {
                            setNewRole({ id: "1", name: "Administrateur" });
                            setCustomRole({ analyse: { read: true, write: true }, reduce: { read: true, write: true }, communicate: { read: true, write: true } });
                          }}
                        />
                      </>
                    )}
                    <div className="text-xs font-Poppins-Regular ml-[10px] w-[280px]">
                      <p>Administrateur</p>
                      <p>Accès complet à toutes les fonctionalitées, y compris la gestion des utilisateurs</p>
                    </div>
                  </div>
                  <div className="mt-[20px] ml-[10px] flex">
                    {newrole.id === "2" ? (
                      <>
                        <div className="rounded-full w-[20px] h-[20px] border-blue-500 border-[2px] flex items-center justify-center">
                          <div className="rounded-full w-[10px] h-[10px] bg-blue-500" />
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="rounded-full w-[20px] h-[20px] border-black border-[2px] flex items-center justify-center cursor-pointer"
                          onClick={() => {
                            setNewRole({ id: "2", name: "Éditeur" });
                            setCustomRole({ analyse: { read: true, write: true }, reduce: { read: true, write: true }, communicate: { read: true, write: true } });
                          }}
                        />
                      </>
                    )}
                    <div className="text-xs font-Poppins-Regular ml-[10px] w-[280px]">
                      <p>Éditeur</p>
                      <p>Accès en modification à toutes les propriétées</p>
                    </div>
                  </div>
                  <div className="mt-[20px] ml-[10px] flex">
                    {newrole.id === "3" ? (
                      <>
                        <div className="rounded-full w-[20px] h-[20px] border-blue-500 border-[2px] flex items-center justify-center">
                          <div className="rounded-full w-[10px] h-[10px] bg-blue-500" />
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="rounded-full w-[20px] h-[20px] border-black border-[2px] flex items-center justify-center cursor-pointer"
                          onClick={() => {
                            setNewRole({ id: "3", name: "Lecteur" });
                            setCustomRole({ analyse: { read: true, write: false }, reduce: { read: true, write: false }, communicate: { read: true, write: false } });
                          }}
                        />
                      </>
                    )}
                    <div className="text-xs font-Poppins-Regular ml-[10px] w-[280px]">
                      <p>Lecteur</p>
                      <p>Accès en lecture à toutes les propriétées</p>
                    </div>
                  </div>
                  <div className="mt-[20px] ml-[10px] flex">
                    {newrole.id === "4" ? (
                      <>
                        <div className="rounded-full w-[20px] h-[20px] border-blue-500 border-[2px] flex items-center justify-center">
                          <div className="rounded-full w-[10px] h-[10px] bg-blue-500" />
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="rounded-full w-[20px] h-[20px] border-black border-[2px] flex items-center justify-center cursor-pointer"
                          onClick={() => {
                            setNewRole({ id: "4", name: "Attribuer les rôles" });
                          }}
                        />
                      </>
                    )}
                    <div className="text-xs font-Poppins-Regular ml-[10px] w-[280px]">
                      <p>Attribuer les rôles</p>
                    </div>
                  </div>
                  {newrole.id === "4" ? (
                    <>
                      <div className="w-full flex items-center justify-center mt-[10px]">
                        <div className="w-[300px] border-b-[1px] border-black" />
                      </div>
                      <div className="w-full flex justify-center mt-[10px]">
                        <div className="w-[230px]">
                          <div className="flex justify-between text-xs font-Poppins-Regular">
                            <div className="w-[100px]" />
                            <div className="w-[65px] flex justify-center items-center">
                              <p>Lecteur</p>
                            </div>
                            <div className="w-[65px] flex justify-center items-center">
                              <p>Editeur</p>
                            </div>
                          </div>
                          <div className="flex justify-between text-xs font-Poppins-Regular">
                            <div className="w-[100px]">Analyse</div>
                            <div className="w-[65px] flex justify-center items-center">
                              <input
                                type={"checkbox"}
                                defaultChecked={customRole.analyse.read}
                                onClick={() => {
                                  let change = customRole;
                                  change.analyse.read = !change.analyse.read;
                                  setCustomRole(change);
                                }}
                              />
                            </div>
                            <div className="w-[65px] flex justify-center items-center">
                              <input
                                type={"checkbox"}
                                defaultChecked={customRole.analyse.write}
                                onClick={() => {
                                  let change = customRole;
                                  change.analyse.write = !change.analyse.write;
                                  setCustomRole(change);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between text-xs font-Poppins-Regular">
                            <div className="w-[100px]">Réduction</div>
                            <div className="w-[65px] flex justify-center items-center">
                              <input
                                type={"checkbox"}
                                defaultChecked={customRole.reduce.read}
                                onClick={() => {
                                  let change = customRole;
                                  change.reduce.read = !change.reduce.read;
                                  setCustomRole(change);
                                }}
                              />
                            </div>
                            <div className="w-[65px] flex justify-center items-center">
                              <input
                                type={"checkbox"}
                                defaultChecked={customRole.reduce.write}
                                onClick={() => {
                                  let change = customRole;
                                  change.reduce.write = !change.reduce.write;
                                  setCustomRole(change);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between text-xs font-Poppins-Regular">
                            <div className="w-[100px]">Communication</div>
                            <div className="w-[65px] flex justify-center items-center">
                              <input
                                type={"checkbox"}
                                defaultChecked={customRole.communicate.read}
                                onClick={() => {
                                  let change = customRole;
                                  change.communicate.read = !change.communicate.read;
                                  setCustomRole(change);
                                }}
                              />
                            </div>
                            <div className="w-[65px] flex justify-center items-center">
                              <input
                                type={"checkbox"}
                                defaultChecked={customRole.communicate.write}
                                onClick={() => {
                                  let change = customRole;
                                  change.communicate.write = !change.communicate.write;
                                  setCustomRole(change);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className="w-full mt-[20px] h-[80px] flex items-center justify-center">
                    <div className="w-[150px] h-full">
                      <button
                        className="bg-mainGreen rounded-lg w-[150px] h-[30px]"
                        onClick={() => {
                          setAddMenu(1);
                          setRoleSelected(newrole);
                        }}
                      >
                        <p className="text-white font-Poppins-SemiBold text-sm">Valider</p>
                      </button>
                      <button
                        className="mt-[10px] w-[150px] h-[30px]"
                        onClick={() => {
                          setAddMenu(1);
                          setNewRole(roleSelected);
                        }}
                      >
                        <p className="text-mainGreen font-Poppins-SemiBold text-sm">Annuler</p>
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
          <div
            className="bg-[#F8FAFB] w-full h-[35px] rounded-lg flex justify-between align-center items-center cursor-pointer"
            onClick={() => {
              setAddMenu(2);
            }}
          >
            {roleSelected.id === "0" ? <p className="text-sm pl-[10px] font-Poppins-Light  mt-[5px] text-[#A2A3AF]">Sélectioner un rôle</p> : null}
            {roleSelected.id === "1" ? <p className="text-sm pl-[10px] font-Poppins-Light mt-[5px] text-[#A2A3AF]">Administrateur</p> : null}
            {roleSelected.id === "2" ? <p className="text-sm pl-[10px] mt-[5px] text-[#A2A3AF]">Editeur</p> : null}
            {roleSelected.id === "3" ? <p className="text-sm pl-[10px] font-Poppins-Light mt-[5px] text-[#A2A3AF]">Lecteur</p> : null}
            {roleSelected.id === "4" ? <p className="text-sm pl-[10px] font-Poppins-Light mt-[5px] text-[#A2A3AF]">Personalisé</p> : null}
            <div className="border-[#A2A3AF] mr-[15px] flex items-center justify-center">
              <BackArrow transform="rotate(270)" />
            </div>
          </div>
        </div>
        <div className="w-full h-[180px] flex justify-center items-end">
          <div className="w-[160px]">
            <div class="flex items-center justify-center mt-8 h-[40px]">
              {/* <MainButton title={"Se connecter"} callback={async () => await sendSignInLinkEmail_rd({ "creds": creds, "navigate": navigate, "signInPersistence": signInPersistence })} /> */}
              <MainButton disabled={user_info.organization_info.role.access.analyse.write} title={is_modify_user ? "Modifier" : "Ajouter"} callback={async () => await addButtonCallBack()} />
            </div>

            <button
              className="w-[160px] h-[40px] rounded-lg text-mainGreen font-Poppins-SemiBold text-sm"
              onClick={() => {
                setAddMenu(0);
              }}
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUserMenu;
